<div class="base-container">
  @let trendDataValue = trendData();
  @if (trendDataValue.length > 0) {
    <!-- TRENDS LOOP -->
    @for (singleTrend of trendDataValue; track $index) {
      <mat-card appearance="outlined" class="trend-item-card">
        <!-- Dekoratives Logo oben rechts -->
        <div class="trend-card-logo">
          <fa-icon [icon]="['far', 'chart-line']" size="2x"></fa-icon>
        </div>

        <mat-card-content class="trend-card-body">
          <h2 class="trend-headline">
            {{ 'PRODUCT.TREND.HEADLINE' | translate }}
            <span class="trend-location">{{
              translationOfIdsAndNames()[singleTrend.id]
            }}</span>
          </h2>

          <div class="trend-meta-info">
            <fa-icon [icon]="['far', 'user-edit']" class="meta-icon"></fa-icon>
            <strong>
              {{
                singleTrend?.writtenAt
                  | datex
                    : 'DD.MM.YY HH:mm'
                    : undefined
                    : languageService.langSignal()
              }}
              &bull;
              {{ 'PRODUCT.TREND.UPDATED_BY' | translate }}:
              <span class="trend-author">{{ singleTrend?.author }}</span>
            </strong>
          </div>

          <div class="trend-text-content">
            @for (paragraph of singleTrend?.text.split('\n\n'); track $index) {
              <p class="trend-paragraph">
                {{ paragraph }}
              </p>
            }
          </div>
        </mat-card-content>
      </mat-card>
    }
  } @else {
    <!-- TEMPLATE: NO TREND -->
    <mat-card appearance="outlined" class="trend-item-card trend-empty-state">
      <mat-card-content class="trend__no-text">
        <fa-icon
          [icon]="['far', 'comment-alt-slash']"
          size="3x"
          class="empty-icon"></fa-icon>
        <p>{{ 'PRODUCT.TREND.NOTEXT' | translate }}</p>
      </mat-card-content>
    </mat-card>
  }
</div>
